export class EidNotFoundError extends Error {
    constructor(public readonly eId: string) {
        super(`eID not found: ${eId}`);
        this.name = 'EidNotFoundError';
    }
}
